import { inject } from "@angular/core";
import { CanActivateFn, RedirectCommand, Router } from "@angular/router";

export const googleAuthGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);

  //HANDLE GOOGLE (data returns in fragment)
    const hash = window.location.hash;
    const hashFragments = new URLSearchParams(hash.substring(1));
    const googleToken = hashFragments.get('access_token');

    if (googleToken && !route.queryParamMap.has('handled')) {
        const googleState = hashFragments.get('state');
        const googleQueryParams:Record<string, any> = {};
        if(googleState){
            const parsedState = JSON.parse(googleState);
            Object.entries(parsedState).forEach(([key, value])=>googleQueryParams[key] = value);
        }
        if(googleToken){
            googleQueryParams['google_token'] = googleToken;
        }
        googleQueryParams['handled'] = 'true';

        let destination = '/profile';
        if(googleQueryParams['destination'] === 'p'){
            destination = '/p'
        }
        const newUrl = router.createUrlTree([destination], { queryParams: googleQueryParams} );
        console.log('google redirect', newUrl);
        return new RedirectCommand(newUrl);
    }
   
    return true;
};